import Table from '/src/components/table';
import capitalizeFirstLetter from '../../../../../utils/capitalizeFirstLetter';
import { useNavigate } from 'react-router-dom';
import { PageTable, Header } from '/src/layouts/page/index';
import './AnalyticsView.css';
import AnalyticsContainer from './AnalyticsContainer/AnalyticsContainer';
import AnalyticsTopBar from './AnalyticsTopBar/AnalyticsTopBar';
import Popup from '/src/features/editor/components/Popup/Popup';

function AnalyticsView({name}) {
    const navigate = useNavigate();
    
    const cells = [
        {
            column : 'Name', 
            name: 'name', 
            show : (value) => capitalizeFirstLetter(value)
        },
        {
            column : 'Language',
            name: 'language.slug', 
            show : (value) => <span className={"flag-icon flag-icon-" + value.toLowerCase() }/>
        }
    ];
    
    return (
        <>
            <AnalyticsTopBar name={name}/>
            <AnalyticsContainer/>
            <Popup id="analytics-popup"/>
        </>
    )
}

export default AnalyticsView;